module.exports = __webpack_public_path__ + "img/white-heart.20da2a8d.svg";